import {Button as SharedButton, ButtonType} from "@bounce/shared/ui";
import {Colors} from "@bounce/shared/ui";

const bluePrimarySx = {
  "contained-primary": {
    backgroundColor: Colors.blue._700,
    "&:hover": {backgroundColor: Colors.blue._800},
  },
  "outlined-primary": {
    color: Colors.blue._700,
    borderColor: Colors.blue._300,
    "&:hover": {borderColor: Colors.blue._700, backgroundColor: Colors.blue._100},
  },
} as const;

export const Button = ({sx, buttonType, ...props}: ButtonType) => (
  <SharedButton
    buttonType={buttonType}
    sx={{
      borderRadius: "8px",
      ...(buttonType && buttonType in bluePrimarySx
        ? bluePrimarySx[buttonType as keyof typeof bluePrimarySx]
        : {}),
      ...sx,
    }}
    {...props}
  />
);
